import { EventsByDate } from '../../types/GroupsArrayType';

export default function shallowCopyEvents(eventsByDay: EventsByDate): EventsByDate {
  const eventsCopy = {};
  Object.keys(eventsByDay).forEach((key) => {
    eventsCopy[key] = [...eventsByDay[key]];
  });

  return eventsCopy;
}
